import { c as _c } from "react/compiler-runtime";
import type { UserConsent } from '@onefootprint/request-types';
import { useMatch } from '@tanstack/react-router';
import { useIsNavigationOverridden } from './use-navigation-override';

/**
 * The consent the shell displays as a footer. Inner pages of multipage requirements take over the
 * shell, so it only shows on pages whose CTA proceeds to the next requirement.
 */
export const useRequiredConsent = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      from: "/onboarding/$token",
      shouldThrow: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onboardingMatch = useMatch(t0);
  const isNavigationOverridden = useIsNavigationOverridden();
  if (isNavigationOverridden) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [];
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onboardingMatch?.context?.requiredConsent) {
    t1 = onboardingMatch?.context?.requiredConsent ?? [];
    $[2] = onboardingMatch?.context?.requiredConsent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};